import { HelperResult, InsurancePolicies } from '@openclassrooms/sdk-web';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

interface GetParams {
  userId: number;
}

interface CreateParams {
  userId: number;
  context: string;
}

const {
  useFind: useInsurancePolicies,
  useCreate: useCreateInsurancePolicies,
  useDelete: useDeleteInsurancePolicies,
} = getCRUDHooks({
  entityName: 'InsurancePolicies',

  find: ({ userId }: GetParams): HelperResult<InsurancePolicies> =>
    clientApi.getOCClient().helpers.user.users.id(userId).insurancePolicies.find(),

  create: (values: {}, { userId, context }: CreateParams): HelperResult<InsurancePolicies> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .insurancePolicies.create(values, false)
      .setHeader('X-Request-Context', context)
      .execute(),

  remove: ({ userId }: { userId: number }): HelperResult<void> =>
    clientApi.getOCClient().helpers.user.users.id(userId).insurancePolicies.delete(),
});

export { useInsurancePolicies, useCreateInsurancePolicies, useDeleteInsurancePolicies };
